<template>
  <div>
    <draggable
      tag="ul"
      :list="list"
      v-bind="dragOptions"
      @start="isDragging = true"
      @end="isDragging = false"
       class="el-upload-list el-upload-list--picture-card"
      @sort="updateSort">
      <li
        class="el-upload-list__item is-ready"
        v-for="(img, index) in list"
        :key="index"
      >
        <img :src="img.path" class="list-image" />
        <div class="list-image-del">
          <img
            src="@/assets/svg/del.svg"
            alt=""
            class="deleicon"
            @click="delImg(index)"
          />
        </div>
      </li>
    </draggable>
    <div class="upload" v-show="inMaxCount">
      <div
        class="upload-action"
        :class="['upload-action-' + size]"
        :id="`upload_image_${idFlag}`"
      >
        <template>
          <img src="@/assets/images/add.png" class="add-icon" alt="" />
          <div class="tips">上传图片</div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import { initwebupload } from "@/utils/webuplaoderCon";
export default {
  name: "UploadImage",
  components: {draggable},
  props: {
    value: [Array],
    size: {
      type: String,
      default: "normal"
    },
    maxCount: {
      type: Number,
      default: 20
    },
    idFlag: {
      type: String,
      default: "0"
    },
    imgWidth: {
      type: Number,
      default: 0
    },
    imgHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [],
      isDragging: false
    };
  },
  computed: {
    inMaxCount() {
      return this.list.length < this.maxCount;
    },
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.list = [...newVal];
      }
    }
  },
  mounted() {
    this.fileUploadFun();
  },
  methods: {
    emitInputValue() {
      this.$emit("input", [...this.list]);
    },
    delImg(index) {
      this.list.splice(index, 1);
      this.emitInputValue();
    },
    backFun(backValue) {
      const minImgWidth = this.imgWidth;
      const minImgHeight = this.imgHeight;
      console.log("minImgWidth=", minImgHeight, "minImgHeight=", minImgHeight);
      console.log("this=", this);
      const that = this;
      const img = new Image();
      img.src = backValue.fileUrl;
      img.onload = function() {
        // 是否需要宽高校验
        if (minImgWidth && minImgHeight) {
          // 需要-是否满足条件
            if (this.width >= minImgWidth && this.height >= minImgHeight) {
              // 满足条件-走原来逻辑
              that.list.push({
                path: backValue.fileUrl,
                name: backValue.fileName
              });
              that.emitInputValue();
            } else {
              // 不满足条件-给出提示
             that.$message.error("图片上传尺寸不可低于640×360，请重新上传！");
             }
        } else {
          // 不需要-走原来逻辑
          that.list.push({
           path: backValue.fileUrl,
           name: backValue.fileName
         });
        that.emitInputValue();
        }
      };
    },
    updateSort() {
      this.emitInputValue();
    },
    fileUploadFun() {
      initwebupload(`#upload_image_${this.idFlag}`, "images", this.backFun);
    }
  }
};
</script>
<style lang="scss" scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.list-image {
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  &-del {
    cursor: pointer;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 8px;
    right: 8px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.upload {
  display: inline-block;
  &-action {
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: content-box;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      border-color: #409eff;
    }
    &-normal {
      width: 148px;
      height: 148px;
    }
    &-small {
      width: 72px;
      height: 72px;
    }
    /deep/.webuploader-pick-new {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .add-icon {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
